var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.462 2.658c.717.374.717 1.31 0 1.684L1.615 6.868C.897 7.243 0 6.775 0 6.026V.974C0 .225.897-.243 1.615.132z"}));
}

Triangle.defaultProps = {"viewBox":"0 0 7 7"};

module.exports = Triangle;

Triangle.default = Triangle;
